/* eslint-disable react/no-array-index-key */
import React from 'react';
import ContentLoader from 'react-content-loader';
import * as Styled from './Modal.styles';

var SkeletonLoadingContent = function SkeletonLoadingContent(_ref) {
  var partNumbers = _ref.partNumbers;
  if (partNumbers.length === 0) return /*#__PURE__*/React.createElement(SkeletonLoader, null);
  return partNumbers.map(function (_ignore, index) {
    return /*#__PURE__*/React.createElement(SkeletonLoader, {
      key: index
    });
  });
};

var ModalSkeleton = function ModalSkeleton(_ref2) {
  var _ref2$partNumbers = _ref2.partNumbers,
      partNumbers = _ref2$partNumbers === void 0 ? [] : _ref2$partNumbers;
  return /*#__PURE__*/React.createElement(Styled.SkeletonWrapper, null, /*#__PURE__*/React.createElement(SkeletonLoadingContent, {
    partNumbers: partNumbers
  }));
};

var SkeletonLoader = function SkeletonLoader(_ref3) {
  var _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 72 : _ref3$height,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 470 : _ref3$width,
      _ref3$speed = _ref3.speed,
      speed = _ref3$speed === void 0 ? 1 : _ref3$speed,
      _ref3$primaryColor = _ref3.primaryColor,
      primaryColor = _ref3$primaryColor === void 0 ? '#e7e7e7' : _ref3$primaryColor,
      _ref3$secondaryColor = _ref3.secondaryColor,
      secondaryColor = _ref3$secondaryColor === void 0 ? '#e0e0e0' : _ref3$secondaryColor;
  return /*#__PURE__*/React.createElement(Styled.Container, {
    loading: "true"
  }, /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor,
    uniqueKey: "add-to-trolley-modal-skeleton"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "85",
    y: "6",
    rx: "3",
    ry: "3",
    width: "85",
    height: "15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "85",
    y: "46",
    rx: "3",
    ry: "3",
    width: "290",
    height: "15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "6",
    rx: "0",
    ry: "0",
    width: "55",
    height: "55"
  })));
};

export default ModalSkeleton;